import * as yup from "yup";

export const TrustBankSetupValidationSchema = yup.object().shape({
    trustBankName: yup
		.string()
		.required("Trust Bank Name is required")
		.max(50, " Trust Bank Name has at most 50 characters"),
	debitClientId: yup
		.string()
		.required("Debit Client Id is required")
		.max(50, " Debit Client Id has at most 50 characters"),
	debitTransactionCode: yup
		.string()
		.required("Debit Transaction Code is required")
		.max(20, "Debit Transaction Code has at most 20 characters"),
	creditTransactionCode: yup
		.string()
		.required("Credit Transaction Code is required")
		.max(20, "Credit Transaction Code has at most 20 characters"),
	creditClientId: yup
		.string()
		.required("Credit Client Id is required")
		.max(50, " Credit Client Id has at most 50 characters"),
	clientName: yup
		.string()
		.required("client Name is required")
		.max(100, " client Name has at most 100 characters"),
	clientShortName: yup
		.string()
		.required("Client Short Name is required")
		.max(15, " Client Short Name has at most 15 characters"),
	bankAccountNo: yup
		.string()
		.required("Bank Account No is required")
		.max(18, " CBank Account No has at most 18 characters"),
	financialInstitutionNo: yup
		.string()
		.required("Financial Institution No is required")
		.max(4, "Financial Institution No has at most 4 characters"),
	bankTransitNo: yup
		.string()
		.required("Bank Transit No is required")
		.max(5, "Bank Transit No has at most 5 characters"),
	accountTitle: yup
		.string()
		.required("Account Title is required")
		.max(50, "Account Title has at most 50 characters"),
});
